import {inject} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {ModalController} from '@ionic/angular';
import {SharedConfirmLeaveModalComponent} from "@shared/components/confirm-leave-modal/shared-confirm-leave-modal.component";
import {TechInventoryMissionPagesService} from "@tech/pages/inventory/pages/mission-detail/services/tech-mission-pages.service";
import {EAssignedUser} from "@tech/pages/inventory/enums/assigned-user.emun";
import {Store} from "@ngrx/store";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {MissionState} from "@server-models";
import {EMissionDetailSegment} from "@tech/pages/inventory/pages/mission-detail/enums/mission-detail-segment.emun";
import {TechInventoryMissionCreatePage} from "@tech/pages/inventory/pages/mission-create/tech-inventory-mission-create-page.component";

async function presentModal(modalCtrl: ModalController): Promise<boolean> {
  const modal = await modalCtrl.create({
    component: SharedConfirmLeaveModalComponent
  });
  await modal.present();

  const { data } = await modal.onWillDismiss();

  return data?.confirmed ? true : false;
}

export const techMissionCreatePageCanLeaveGuard: (
  component: TechInventoryMissionCreatePage,
  router: Router,
  currentState: any,
  nextState: any) => boolean | Promise<boolean | UrlTree> = (
    component,
    router,
    currentState,
    nextState) => {
  const modalCtrl = inject(ModalController);

  // in case it's a submit action
  if (nextState.url.split('/').includes('success')) {
    return true;
  }

  const canLeave = component?.canLeave ? component.canLeave() : true;
  return canLeave ? true : presentModal(modalCtrl);
};
